<template>
  <CollectionCard>
    <CollectionCardImage :image="item.image">
      <template #back>
        <div class="collection-card-utility-description">
          {{ item.description }}
        </div>
      </template>
    </CollectionCardImage>
    <CollectionCardHeader
      :name="item.name"
      :guild="item.guild"
    />

    <CollectionCardActions
      :items="actions"
      @resurrectTeen="resurrectTeen"
    />
  </CollectionCard>
</template>
<script>
import { computed, defineComponent } from "vue";
import CollectionCardHeader from "../CollectionCard/CollectionCardHeader.vue";
import { TokenType } from "@/config/token-types";
import CollectionCard from "../CollectionCard/CollectionCard.vue";
import CollectionCardImage from "../CollectionCard/CollectionCardImage.vue";
import CollectionCardActions from "../CollectionCard/CollectionCardActions.vue";
import { useWeb3Store } from "@/store/web3";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { CollectionLayouts, useCollectionLayout } from "../useCollectionLayout";

export default defineComponent({
    components: { CollectionCardActions, CollectionCardImage, CollectionCardHeader, CollectionCard },
    props: {
        item: Object,
    },
    setup(props) {
        const walletCollectionStore = useWalletCollectionStore()
        const actions = computed(() => {
            return [
                {
                    name: "Resurrect Teen",
                    event: "resurrectTeen",
                    disabled: walletCollectionStore.gods.findIndex(god => god.guild === props.item.guild) < 0 ||
                        walletCollectionStore.teens.findIndex(teen => teen.guild === props.item.guild) < 0
                }
            ]
        })
        const resurrectTeen = () => {
            useCollectionLayout().switchCollectionLayout(CollectionLayouts.ressurrection, {
                utilityToken: props.item
            })
        }
        return { TokenType, actions, resurrectTeen }
    }
})
</script>
<style lang="scss">
</style>